import { sellerApiClient } from '@api/apiClient/sellerApiClient';
import { TokenResponse } from '@api/Responses/KeycloakTokenResponse';

export type getWeChatQrResponse = {
  authTicket: string;
  qrCode: string;
};

export const getWeChatQrCode = async (type: string, promoId?: string): Promise<getWeChatQrResponse> => {
  const response = await sellerApiClient.get("/v1/wechat/auth/qr", {
    params: {
      type: type,
      promoId: promoId,
    }
  });
  return response.data;
};

export type checkEntryResponse = {
  accessToken?: TokenResponse;
  authTicket: string;
  phone?: string;
  status: string;
};

export const checkEntry = async (authTicket: string): Promise<checkEntryResponse> => {
  const response = await sellerApiClient.get(`/v1/wechat/auth/qr/status?authTicket=${authTicket}`);
  return response.data;
};